import { publicPluginsListSelector } from '@/redux/plugins/plugins.selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { PROJECT_ID } from '@/constants';
import { LoadPlugin } from '../LoadPlugin';

export const PublicPlugins = (): React.ReactNode => {
  const publicPlugins = useSelector(publicPluginsListSelector);

  const availablePlugins = publicPlugins.filter(
    plugin =>
      plugin.availableInProject.includes('*') || plugin.availableInProject.includes(PROJECT_ID),
  );

  return availablePlugins.map(plugin => <LoadPlugin key={plugin.hash} plugin={plugin} />);
};
